import axios from './axios'
import config from '../config'

export default {
    listRoles(params) {
        return axios({
            url: config.backendUrl + '/common/admin/roles',
            method: 'GET',
            params
        })
    },
    addRole(data) {
        return axios({
            url: config.backendUrl + '/common/admin/roles',
            method: 'POST',
            data
        })
    },
    updateRole({id, data}) {
        return axios({
            url: config.backendUrl + '/common/admin/roles/' + id,
            method: 'PUT',
            data
        })
    },
    getRole(id) {
        return axios({
            url: config.backendUrl + '/common/admin/roles/' + id,
            method: 'GET'
        })
    },
    deleteRole(id) {
        return axios({
            url: config.backendUrl + '/common/admin/roles/' + id,
            method: 'DELETE'
        })
    },
    checkRoleName(name) {
        return axios({
            url: config.backendUrl + '/common/admin/roles/check-name',
            method: 'GET',
            params: {name}
        })
    },
    listAllPermissions() {
        return axios({
            url: config.backendUrl + '/common/admin/permissions',
            method: 'GET'
        })
    },
    getRoleGrants(id) {
        return axios({
            url: config.backendUrl + '/common/admin/roles/' + id  + '/grants',
            method: 'GET'
        })
    },
    updateRoleGrants(id, data) {
        return axios({
            url: config.backendUrl + '/common/admin/roles/' + id + '/grants',
            method: 'PUT',
            data
        })
    }
}
